import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Склейка классов с разрешением конфликтов Tailwind (последний выигрывает).
 * Локальный хелпер стиль-ядра — clsx + tailwind-merge уже в зависимостях проекта.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
